module.exports = __webpack_public_path__ + "img/warning.ff790a6e.svg";